import { Component, Host } from '@angular/core';
import { MultiControllerComponent } from '../../multi-controller.component';

@Component({
    selector: 'ms-multi-screen-results',
    templateUrl: './multi-screen-results.component.html',
    styleUrls: ['./multi-screen-results.component.scss'],
    standalone: false
})
export class MultiScreenResultsComponent {
  constructor(@Host() public readonly multiController: MultiControllerComponent) {}
}
